import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import { LiaShoppingBagSolid } from "react-icons/lia";
import { BsFilterRight } from "react-icons/bs";
import ApiService from "../services/ApiService";
import PageLoader from "../components/PageLoader";
import {formatDate} from "../utils/helper";
import {statusColor} from "../utils/statusColors";
import { toast } from "react-toastify";
import { Dropdown, Form } from 'react-bootstrap';
import Header from "../components/Header";
import Swal from 'sweetalert2';

const MyOrders = () => {

  const [orders, setOrders] = useState([]);
  const [isLoader, setIsLoader] = useState(false);

  const [showFilter, setShowFilter] = useState(false);
  const [status, setStatus] = useState('All');
  const [selectedFilter, setSelectedFilter] = useState('All');

  const filterOptions = [
    'All',
    'Active',
    'Completed',
    'Cancelled'
  ];

  const handleFilterChange = (option) => {
    setSelectedFilter(option);
    setShowFilter(false);
    setStatus(option);
  };
  
  useEffect(() => {
    window.scrollTo(0, 0);
    getMyOrders();
  }, [status]);

  const getMyOrders = async () => {
    try {
      setIsLoader(true);
      const response = await ApiService.request({
        method: "GET",
        url: "/getMyOrders",
        data: {status:(status=="Completed")?"Delivered":status}
      });
      const data = response.data;

      if (data.status) {
        setOrders(data.data?.orders);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setIsLoader(false);
    }
  };

  return (
    <div className="">
      {isLoader ?(
        <PageLoader />
      ):(
        <div className="main-heading container">
            <Header title={'My Orders'} back={'/'}/>


          <div className="all-orders">
            <div className="d-flex justify-content-between align-items-center p-4">
              <h4>{selectedFilter} Orders</h4>

              {/* <BsFilterRight fontSize={40}  /> */}
              <Dropdown show={showFilter} onToggle={setShowFilter}>
                <Dropdown.Toggle as="div" className="filter-toggle">
                  <BsFilterRight 
                    fontSize={40} 
                    style={{ cursor: 'pointer' }}
                    onClick={() => setShowFilter(!showFilter)}
                  />
                </Dropdown.Toggle>

                <Dropdown.Menu align="end" className="p-3">
                  <Form>
                    {filterOptions.map((option, index) => (
                      <Form.Check
                        key={option}
                        type="radio"
                        id={`filter-${option}`}
                        label={option+' Orders'}
                        name="orderFilter"
                        checked={selectedFilter === option}
                        onChange={() => handleFilterChange(option)}
                        className="mb-2"
                      />
                    ))}
                  </Form>
                </Dropdown.Menu>
              </Dropdown>
            </div>
              {orders && orders.map((order, index) => (
                <div className="order-list p-4 rounded-5 m-3 shadow-sm">
                  <div className="d-flex justify-content-between">
                    <p className="fw-bold fs-5">{order?.title}</p>
                    <p className="order-id">Order ID {order?.order_code}</p>
                  </div>
                  <div>
                    <span className="fw-bold">
                      Branch:
                      <span className="text-secondary fw-light ms-2">
                        {order?.branch?.name}
                      </span>
                    </span>
                    <p className="fw-bold">
                      Date & Time:
                      <span className="text-secondary fw-light ms-2">
                        {formatDate(order?.createdAt,'DD MMM YYYY, hh:mm A')}
                      </span>
                    </p>
                    <p className="fw-bold fs-5">
                      AED  {order?.grand_total}
                      {order?.payment_status !== 'Failed' &&
                        <span className={`badge  order-${statusColor[order.status]} rounded fw-normal ms-3 fs-6`}>
                          {order?.status}
                        </span>
                      }
                      <span className={`badge  order-${statusColor[order.payment_status]} rounded fw-normal ms-3 fs-6`}>
                        Payment: {order?.payment_status}
                      </span>
                    </p>
                    <div className="order-btns d-flex ">
                      {/* <button className="btn btn-lg rounded-pill">Order Again</button> */}
                      <Link to={'/order/'+order._id}>
                        <button className="btn btn-lg rounded-pill ms-3 more-details">
                          More Details
                        </button>
                      </Link>
                      {/* {order?.payment_status !== 'Paid' && (
                        <Link to={'/order/'+order._id}>
                          <button className="btn btn-lg rounded-pill ms-3 more-details">
                            Pay Now
                          </button>
                        </Link>
                      )} */}
                    </div>
                  </div>
                </div>
              ))}
              {orders.length < 1 &&
              <h6 className="my-5 text-center"> <i className="bi bi-map-marker"></i>
                No Order found!</h6>
              }
           
          </div>
        </div>
      )}
    </div>
  );
};

export default MyOrders;
